import { Component, computed, OnInit, Signal } from '@angular/core';

import { ProfileInfoBoxComponent } from '../../profile-info-box.component';
import { ProfileImageLoaderComponent } from '../../../profile-image-loader/profile-image-loader.component';
import { ProfileInfoBoxBaseComponent } from '../profile-info-box-base.component';
import { FormRowComponent } from '../../../../form/form-row/form-row.component';
import { FormFieldComponent } from '../../../../form/form-field/form-field.component';
import { IMDDropDownOption, MDDatePickerInputDirective, MDDropDownComponent } from '@melodic-ui/components';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
	selector: 'lb-profile-personal-info-box',
	standalone: true,
	imports: [
    FormsModule,
    ReactiveFormsModule,
    ProfileInfoBoxComponent,
    ProfileImageLoaderComponent,
    FormRowComponent,
    FormFieldComponent,
    MDDropDownComponent,
    MDDatePickerInputDirective
],
	templateUrl: './profile-personal-info-box.component.html',
	styleUrl: './profile-personal-info-box.component.scss'
})
export class ProfilePersonalInfoBoxComponent extends ProfileInfoBoxBaseComponent implements OnInit {
	public pronounOptions: Signal<IMDDropDownOption[]> = computed(() => {
		const pronounOpts = this._profileSupportDateStateService.pronouns().map((pronoun) => {
			return {
				value: pronoun.pronounID,
				label: pronoun.pronounName
			} as IMDDropDownOption;
		});

		pronounOpts.unshift({
			value: null,
			label: 'Not Specified'
		});

		return pronounOpts;
	});

	public genderOptions: Signal<IMDDropDownOption[]> = computed(() => {
		const genderOpts = this._profileSupportDateStateService.genders().map((gender) => {
			return {
				value: gender.genderID,
				label: gender.genderName
			} as IMDDropDownOption;
		});

		genderOpts.unshift({
			value: null,
			label: 'Not Specified'
		});

		return genderOpts;
	});
	ngOnInit(): void {
		const form: FormGroup = this.form();
		const isDisabled = this.formDisabled() || false;

		const dateOfBirth: string | null = this.profile().dateOfBirth ? (this.profile().dateOfBirth?.slice(0, 10) as string) : null;

		form.addControl('firstName', new FormControl({ value: this.profile().firstName, disabled: true }, { validators: [Validators.required] }));
		form.addControl('lastName', new FormControl({ value: this.profile().lastName, disabled: true }, { validators: [Validators.required] }));
		form.addControl('preferredName', new FormControl({ value: this.profile().preferredName, disabled: isDisabled }));
		form.addControl('dateOfBirth', new FormControl({ value: dateOfBirth, disabled: true }));
		form.addControl('pronoun', new FormControl({ value: this.profile().pronounID, disabled: isDisabled }));
		form.addControl('gender', new FormControl({ value: this.profile().genderID, disabled: true }));
		form.addControl('userImage', new FormControl({ value: this.profile().userImage, disabled: isDisabled }));
	}

	setProfileImage(dataUrl: string | undefined): void {
		this.form().get('userImage')?.setValue(dataUrl);
	}
}
